import React, { useEffect, useRef, useState } from 'react'

import {
    getProcessButtons, getDtRowIndexNew, getError, isUndNullNew, sendMessageCloseCurrentWindow, getLanguageObj, getResponse,
    settings, LoadingSection
} from '../../helpers/UtilsHelper';
import useAuth from '../../auth/useAuth';
import Menu from '../main/Menu';
import { GlobalFormats } from '../../classes/main/globalFormatClass';
import { MlCategoryService } from '../../services/mercadoLibre/MlCategoryService';
import TableIndex from '../main/TableIndex';

const $ = window?.$;
const { app, firebase, icons, images, labels, } = settings;
const { fields: dbFields, ordersBy: dbOrdersBy, } = firebase?.firestore;
const { urls } = app?.backend;

const currentMethod = 'MlCategories - function';

export default function MlCategories({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
} = {}) {
    //#region variables
    const auth = useAuth();
    const dtCategoriesId = 'dtCategories';
    const [process, setProcess] = useState({ showLoading: false, sync: false });
    const isMount = useRef(true);
    //#endregion variables

    //#region methods
    const getCategoryAddEditDelete = async ({
        e = null,
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'getCategoryAddEditDelete';
        let response = getResponse({ type: 0 });
        try {
            if (e) e.preventDefault();
            setProcess(prev => ({ ...prev, showLoading: true }));

            console.log({ id, description, rowIndex, processType, subMethod });
            // Logic for different processTypes (Add/Edit/Delete/Sync) goes here
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const getData = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region dataTable / queryCode
            response = setDataTable({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setQueryCode({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion dataTable / queryCode

            //#region get data (categories)
            const token = auth?.account?.tokenVzLaML?.token;
            const ordersBy = [
                { field: dbFields?.name, value: dbOrdersBy?.asc, },
            ];

            response = await MlCategoryService.getAll({ token, ordersBy, subMethod: currentMethod });

            if (!response?.isSuccess || response?.isWarning) return;

            const categoriesLocal = response?.result || [];
            //#endregion get data (categories)

            //#region set dataTable
            let categoriesDtLocal = [];
            if (categoriesLocal?.length > 0) {
                categoriesDtLocal = categoriesLocal.map((detail) => {
                    return [
                        detail?.name,
                        detail?.categoryId,
                        getProcessButtons({
                            id: detail?.id,
                            description: detail?.name,
                            detailsShow: false,
                            editShow: false,
                            deleteShow: true,
                            deleteLabel: labels?.delete?.[languageObj?.id],
                            deleteEnabled: true,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        })?.result
                    ];
                });
            }

            $(`#${dtCategoriesId}`).DataTable().clear().rows.add(categoriesDtLocal).draw(true);
            //#endregion set dataTable
        } catch (ex) {
            response = getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        } finally {
            if (!isMount?.current) return;
            setProcess(prev => ({ ...prev, showLoading: false }));

            await sendMessageCloseCurrentWindow({
                response: response,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });
        }
    }

    const setDataTable = ({
        subMethod = '',
    }) => {
        const currentMethod = 'setDataTable';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtCategoriesId}`).DataTable({
                destroy: true,
                data: [],
                order: [[0, 'desc']],
                columns: [
                    { title: labels?.name?.[languageObj?.id], width: '85%', orderable: true, },
                    { title: labels?.code?.[languageObj?.id], width: '10%', orderable: true, },
                    { className: 'text-center', title: labels?.process?.[languageObj?.id], width: '5%', orderable: false, searchable: false },
                ],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis'],
            }).buttons().container().appendTo(`#${dtCategoriesId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    }) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtCategoriesId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowIndexLocal = getDtRowIndexNew({ dtId: dtCategoriesId, this_: this, subMethod: currentMethod })?.result;
                if (!isUndNullNew({ data: rowIndexLocal, subMethod: currentMethod, })?.result) {
                    const methodValueLocal = e?.target?.attributes?.method?.value || '';
                    const idLocal = e?.target?.attributes?.id?.value || '';
                    const descriptionLocal = e?.target?.attributes?.description?.value || '';
                    switch (methodValueLocal) {
                        case 'edit':
                            getCategoryAddEditDelete({
                                e: e,
                                id: idLocal,
                                description: descriptionLocal,
                                rowIndex: rowIndexLocal,
                                processType: 1,
                                subMethod: currentMethod
                            });
                            break;
                        case 'delete':
                            getCategoryAddEditDelete({
                                e: e,
                                id: idLocal,
                                description: descriptionLocal,
                                rowIndex: rowIndexLocal,
                                processType: -1,
                                subMethod: currentMethod
                            });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            return getError({ ex: ex, response: response, currentMethod_: currentMethod, subMethod_: subMethod });
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({
            subMethod: 'form - onLoad',
        });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName='settings' process='metrics' processLevel1='categories' />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Premium Bar) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.categories?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href={urls?.home}>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.categories?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='card border-0 shadow-lg login-card' >
                            <LoadingSection alt='loadingSection'
                                className='overlay dark text-white'
                                height={20}
                                hidden={!process?.showLoading}
                                width={20}
                                languageId={languageObj?.id}
                                subMethod={currentMethod} />

                            <div className='card-header bg-white border-0 pt-4 px-4'>
                                <div className='d-flex align-items-center justify-content-between'>
                                    <div className='d-flex align-items-center'>
                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                            <img alt='imgCategories'
                                                style={{ width: '25px', height: '25px', objectFit: 'contain' }}
                                                src={images?.icons?.categories} />
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.categories?.[languageObj?.id]}</h5>
                                            <div className='mt-1'>
                                                <span className='badge badge-pill badge-primary px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                    <i className={`${icons?.fasFa?.list} mr-1`}></i> {labels?.index?.[languageObj?.id]}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <button className='btn btn-primary shadow-sm font-weight-bold px-4 btn-primary'
                                        disabled={process?.showLoading}
                                        onClick={(e) => getCategoryAddEditDelete({ e: e, id: '', description: '', rowIndex: 0, processType: 3, subMethod: 'btnSync' })}
                                        title={labels?.sync?.[languageObj?.id]}>
                                        <i className={`${icons?.sync} mr-1`} /> {labels?.sync?.[languageObj?.id]}
                                    </button>
                                </div>
                            </div>

                            <div className='card-body px-4 pb-4'>
                                <TableIndex tableId={dtCategoriesId} languageObj={languageObj} />
                            </div>

                        </div>

                    </div>
                </section>

            </div>
        </div>
    )
}